module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-jumbotron', {
    attrs: {
      "header": "slotlist.info",
      "lead": "ArmA 3 Missions- und Slotlist-Management"
    }
  }, [_c('p', {
    staticClass: "text-justify"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" ermöglicht das Erstellen und Verwalten von\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'missionList'
      }
    }
  }, [_vm._v("Missionen")]), _vm._v(" - inklusive Slotlisten, bei denen Benutzer sich für ihre gewünschten Slots anmelden können.\n    "), _c('br'), _vm._v("Das\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'communityList'
      }
    }
  }, [_vm._v("Community-Feature")]), _vm._v(" erlaubt es Arma-Communities, ihre Gemeinschaft auf unserer Website zu präsentieren und dadurch für ihre selbsterstellten Missionen zu werben.\n    "), _c('br'), _vm._v("Da\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" Steam Single Sign-on benutzt, wird keine lästige Registrierung und kein weiterer Account auf noch einer weiteren Seite benötigt - alle Authentifizierung wird sicher von den Steam Servern erledigt. Zum Loslegen einfach\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("anmelden")]), _vm._v(" und\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'missionCreator'
      }
    }
  }, [_vm._v("eine neue Mission erstellen")]), _vm._v("!\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v("Weil sich\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" noch immer in der Entwicklungsphase befindet, wird es immer wieder Änderungen an den Seiten und deren Features (oder Daten) geben. Wir werden unser Bestes geben, um Service-Ausfälle möglichst kurz zu halten und Datenverluste zu verhindern.\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'about'
      }
    }
  }, [_vm._v("Kontaktiere uns")]), _vm._v(" aber bitte jederzeit, falls irgendwelche Probleme auftreten sollten oder es Anregungen gibt.\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v("Vielen Dank für die Nutzung unserer Services - ich hoffe, sie sind von gutem Nutzen!\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-muted font-italic"
  }, [_vm._v("— MorpheusXAUT, slotlist.info Entwickler")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59fab283"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/i18n/views/Home.de.vue
// module id = 527
// module chunks = 0